import { useEffect, useState } from "react";
import { CardDetails } from "../../../../common/components/CardDetails/CardDetails"
import style from "./style.module.scss"
import { BagService, ContainerService } from "../../../../common/services/merchandise_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../common/components/Loader/Loader";
import { useLocation } from "react-router";

type storageContainerDetailType = {
  initialValue: any
}

const StorageContainerDetail = ( {initialValue}: storageContainerDetailType) => {

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const locationId = useLocation();
  const [data, setData] = useState<any>({});

  const id = initialValue?.["@id"].split("/").pop();

  useEffect(() => {
    id && getStorageContainer(id);
  }, [initialValue]);

  const getStorageContainer = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await ContainerService.getContainerById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

const renderValue = (value : any /* string | number | boolean */) => {
  return value ? value : "-";
}; 

  return (
    <div>
      <Loader isLoading={isLoading}/>
      <CardDetails className="d-flex gap-2 flex-column">
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Type : </span>
                <span className={style.details__value}>{renderValue(data?.containerType?.containerCategory?.name)} - {renderValue(data?.containerType?.containerUnit?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>État de remplissage : </span>
                <span className={style.details__value}>{renderValue(data?.loadFillingStatus?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Référence : </span>
                <span className={style.details__value}>{renderValue(data?.reference)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>N° Plomb  : </span>
                <span className={style.details__value}>{renderValue(data?.sealNumber)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tonnage : </span>
                <span className={style.details__value}>{renderValue(data?.tonnage)}</span>
              </div>
            </CardDetails>
    </div>
  )
}

export default StorageContainerDetail